import React from "react";

import { useNavigate } from "react-router-dom";
import infiniteLogoBg from "../../assets/images/infiniteBG404.png";

import "./NotFound.scss";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="NotFound">
      <img
        className="NotFound__background"
        loading="lazy"
        src={infiniteLogoBg}
      />
      <div className="NotFound__container">
        <div className="NotFound__title">Oops !</div>
        <div className="NotFound__description">
          We can’t seem to find the page you are looking for
        </div>

        <div className="NotFound__button-outside">
          <div className="NotFound__button-middle">
            <div
              onClick={() => {
                navigate("/");
              }}
              className="NotFound__button"
            >
              Back to Home Page
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
